import "./app/publicPath";

// =========================
// Polyfill's
// =========================

import "custom-event-polyfill";

// =========================
// Framework's
// =========================

import Vue from "vue";
import Vuex from "vuex";
import { mount } from "ceres/mount";

Vue.prototype.$mount = mount;

window.Vue = Vue;
window.Vuex = Vuex;

import script2 from "ceres/app/plugins/script2";
Vue.use(script2);

import "ceres/app/jQuery";

import "bootstrap";
import "owl.carousel";

import {Navigation, Thumbs, Pagination, Autoplay, Zoom, Lazy, Swiper} from 'swiper';
Swiper.use([Navigation, Thumbs, Pagination, Autoplay, Zoom, Lazy]);

import { getUrlParams } from "ceres/app/services/UrlService";
window.ceresEnv = getUrlParams()["env"];

// =========================
// COMPONENTS
// =========================
Vue.component("add-item-to-basket-overlay", () => import("./app/components/basket/AddItemToBasketOverlay.vue"));

Vue.component("add-to-basket", () => import("./app/components/basket/AddToBasket.vue"));
Vue.component("basket-preview", () => import("./app/components/basket/BasketPreview.vue"));
Vue.component("basket-totals", () => import("./app/components/basket/BasketTotals.vue"));
Vue.component("mail-changed-info", () => import("ceres/app/components/basket/MailChangedInfo.vue"));
Vue.component("coupon", () => import("./app/components/basket/Coupon.vue"));
Vue.component("basket-list", () => import("./app/components/basket/list/BasketList.vue"));

Vue.component("step-by-step-navigation", () => import("ceres/app/components/category/StepByStepNavigation.vue"));
Vue.component("google-maps-widget", () => import("ceres/app/components/common/GoogleMaps.vue"));
import LazyImg from "ceres/app/components/common/LazyImg.vue";
Vue.component("lazy-img", LazyImg);
import Intersect from "ceres/app/components/common/Intersect.vue";
Vue.component("intersect", Intersect);
import TabList from "ceres/app/components/common/TabList.vue";
Vue.component("tab-list", TabList);
import TabItem from "ceres/app/components/common/TabItem.vue";
Vue.component("tab-item", TabItem);
Vue.component("last-seen-item-list", () => import("ceres/app/components/containers/LastSeenItemList.vue"));

Vue.component("change-email-form", () => import("ceres/app/components/customer/ChangeEmailForm.vue"));
import ReCaptcha from "ceres/app/components/customer/ReCaptcha.vue";
Vue.component("recaptcha", ReCaptcha);
Vue.component("registration", () => import("ceres/app/components/customer/Registration.vue"));
Vue.component("reset-password-form", () => import("./app/components/customer/ResetPasswordForm.vue"));
Vue.component("forgot-password-modal", () => import("./app/components/customer/login/ForgotPassword.vue"));
Vue.component("guest-login", () => import("ceres/app/components/customer/login/GuestLogin.vue"));
Vue.component("login", () => import("./app/components/customer/login/Login.vue"));
// legacy non-shopbuilder component
Vue.component("login-view", () => import("./app/components/customer/login/LoginView.vue"));
import UserLoginHandler from "./app/components/customer/login/UserLoginHandler.vue";
Vue.component("user-login-handler", UserLoginHandler);
Vue.component("form-attachment", () => import("ceres/app/components/form/FormAttachment.vue"));

Vue.component("item-bundle", () => import("ceres/app/components/item/ItemBundle.vue"));
Vue.component("order-property-value", () => import("ceres/app/components/item/OrderPropertyValue.vue"));
Vue.component("quantity-input", () => import("./app/components/item/QuantityInput.vue"));

Vue.component("tag-list", () => import("ceres/app/components/item/TagList.vue"));

Vue.component("category-item", () => import("./app/components/itemList/CategoryItem.vue"));
import ItemSearch from "./app/components/itemList/ItemSearch.vue";
Vue.component("item-search", ItemSearch);
Vue.component("search-suggestion-item", () => import("ceres/app/components/itemList/SearchSuggestionItem.vue"));
Vue.component("item-filter-list", () => import("./app/components/itemList/filter/ItemFilterList.vue"));
Vue.component("item-filter-tag-list", () => import("./app/components/itemList/filter/ItemFilterTagList.vue"));

Vue.component("live-shopping-item", () => import("ceres/app/components/liveShopping/LiveShoppingItem.vue"));

Vue.component("newsletter-input", () => import("ceres/app/components/newsletter/NewsletterInput.vue"));
Vue.component("newsletter-unsubscribe-input", () => import("ceres/app/components/newsletter/NewsletterUnsubscribeInput.vue"));

Vue.component("order-return", () => import("ceres/app/components/orderReturn/OrderReturn.vue"));

Vue.component("cookie-bar", () => import("ceres/app/components/pageDesign/CookieBar.vue"));
Vue.component("privacy-settings", () => import("ceres/app/components/pageDesign/PrivacySettings.vue"));
Vue.component("carousel", () => import("./app/components/pageDesign/Carousel.vue"));
import Icon from "ceres/app/components/pageDesign/Icon.vue";
Vue.component("icon", Icon);
import LanguageDetection from "ceres/app/components/pageDesign/LanguageDetection.vue";
Vue.component("language-detection", LanguageDetection);
import MobileNavigation from "./app/components/pageDesign/MobileNavigation.vue";
Vue.component("mobile-navigation", MobileNavigation);
import Notifications from "ceres/app/components/pageDesign/Notifications.vue";
Vue.component("notifications", Notifications);
Vue.component("popper", () => import("ceres/app/components/pageDesign/Popper.vue"));
Vue.component("shipping-country-select", () => import("ceres/app/components/pageDesign/ShippingCountrySelect.vue"));
Vue.component("loading-animation", () => import("ceres/app/components/pageDesign/LoadingAnimation.vue"));

Vue.component("wish-list", () => import("./app/components/wishList/WishList.vue"));
import WishListCount from "./app/components/wishList/WishListCount.vue";
Vue.component("wish-list-count", WishListCount);

import LazyLoad from "ceres/app/components/common/LazyLoad.vue";
Vue.component("lazy-load", LazyLoad);

Vue.component("add-to-wish-list", () => import("./app/components/item/AddToWishList.vue"));
Vue.component("graduated-prices", () => import("ceres/app/components/item/GraduatedPrices.vue"));
Vue.component("item-data-table", () => import("ceres/app/components/item/ItemDataTable.vue"));
Vue.component("item-image-carousel", () => import("./app/components/item/ItemImageCarousel.vue"));
Vue.component("item-price", () => import("./app/components/item/ItemPrice.vue"));
Vue.component("set-price", () => import("ceres/app/components/item/SetPrice.vue"));
Vue.component("order-property-list", () => import("ceres/app/components/item/OrderPropertyList.vue"));
Vue.component("variation-select", () => import("./app/components/item/VariationSelect.vue"));
Vue.component("item-availability", () => import("ceres/app/components/item/ItemAvailability.vue"));
Vue.component("single-item-bundle", () => import("ceres/app/components/item/SingleItemBundle.vue"));
Vue.component("single-add-to-basket", () => import("ceres/app/components/item/SingleAddToBasket.vue"));
Vue.component("set-quantity-input", () => import("ceres/app/components/item/SetQuantityInput.vue"));
import SingleItem from "ceres/app/components/item/SingleItem.vue";
Vue.component("single-item", SingleItem);
import SingleItemSetComponent from "ceres/app/components/item/SingleItemSetComponent.vue";
Vue.component("single-item-set-component", SingleItemSetComponent);
// import SingleItem from "./app/components/item/SingleItem.vue";
Vue.component("single-item", SingleItem);

import HomeSliderWidget from "./app/components/home/HomeSliderWidget.vue";
Vue.component("home-slider-widget", HomeSliderWidget);

import HomeAdvantagesWidget from "./app/components/home/HomeAdvantagesWidget.vue";
Vue.component("home-advantages-widget", HomeAdvantagesWidget);

import SEOTextWidget from "./app/components/home/SEOTextWidget.vue";
Vue.component("seo-text-widget", SEOTextWidget);

import NewsletterWidget from "./app/components/footer/NewsletterWidget.vue";
Vue.component("newsletter-widget", NewsletterWidget);

import ODCarousel from "./app/components/itemList/ODCarousel.vue";
Vue.component("od-carousel", ODCarousel);

import HomeIntro from "./app/components/home/HomeIntro.vue";
Vue.component("home-intro", HomeIntro);

import HomeBlog from "./app/components/home/HomeBlog.vue";
Vue.component("home-blog", HomeBlog);

import SingleContact from "./app/components/item/SingleContact.vue";
Vue.component("single-contact", SingleContact);

Vue.component("variation-select-category", () => import("./app/components/item/VariationSelectCategory.vue"));

// Custom BasketSum Component
Vue.component("custom-basket-totals", () => import("./app/components/basket/CustomBasketTotals.vue"));

// custom component for Size + QTY + ATB * Wishlist
Vue.component("size-quantity-select", ()=>import("./app/components/item/SizeQuantitySelect.vue"));

// custom search
import ODSearch from "./app/components/odSearch/ODSearch.vue";
Vue.component("onedot-search", ODSearch);

import ShopTheLook from "./app/components/common/ShopTheLook.vue";
Vue.component("shop-the-look", ShopTheLook);

Vue.component("image-zoom", () => import("./app/components/item/ImageZoom.vue"));

import LazyHydrate from "vue-lazy-hydration";
Vue.component("lazy-hydrate", LazyHydrate);
import ClientOnly from "ceres/app/components/common/ClientOnly.vue";
Vue.component("client-only", ClientOnly);
import BackgroundImg from "ceres/app/components/common/BackgroundImg.vue";
Vue.component("background-img", BackgroundImg);

// =========================
// DIRECTIVES
// =========================
import "ceres/app/directives/basket/basketItemQuantity";
import "ceres/app/directives/basket/basketItemSum";
import "ceres/app/directives/basket/toggleBasketPreview";

import "ceres/app/directives/category/openFilterToolbar";

import "ceres/app/directives/common/truncateTooltip";

import "ceres/app/directives/customer/logout";

import "ceres/app/directives/helper/testingAttr";
import "ceres/app/directives/helper/populateStore";
import "ceres/app/directives/helper/validate";
import "ceres/app/directives/helper/waitingAnimation";
import "ceres/app/directives/helper/waitingAnimationInfinite";

import "ceres/app/directives/navigation/navigationTouchHandler";
import "ceres/app/directives/navigation/openMobileNavigation";

import "ceres/app/directives/pageDesign/scrollToTop";
import "ceres/app/directives/pageDesign/stickInParent";
import "ceres/app/directives/navigation/sidenavigationChildrenLoader";
import "ceres/app/directives/pageDesign/tooltip";


// =========================
// FILTERS
// =========================
import "ceres/app/filters/ageRestriction.filter";
import "ceres/app/filters/arrayFirst.filter";
import "ceres/app/filters/attachText.filter";
import "ceres/app/filters/currency.filter";
import "ceres/app/filters/date.filter";
import "ceres/app/filters/fileName.filter";
import "ceres/app/filters/fileUploadPath.filter";
import "ceres/app/filters/graduatedPrice.filter";
import "ceres/app/filters/hasItemDefaultPrice.filter";
import "ceres/app/filters/inputUnit.filter";
import "ceres/app/filters/itemBundleName.filter";
import "ceres/app/filters/itemCrossPrice.filter";
import "ceres/app/filters/itemImage.filter";
import "ceres/app/filters/itemImageAlternativeText.filter";
import "ceres/app/filters/itemImages.filter";
import "ceres/app/filters/itemName.filter";
import "ceres/app/filters/itemPrice.filter";
import "ceres/app/filters/itemUrl.filter";
import "ceres/app/filters/numberFormat.filter";
import "ceres/app/filters/propertySurcharge.filter";
import "ceres/app/filters/propertyFileUrl.filter";
import "ceres/app/filters/translate.filter";
import "ceres/app/filters/truncate.filter";
import "./app/filters/photoSwipeItemImages.filter";


// =========================
// MIXINS
// =========================
import "ceres/app/mixins/getJsonData.mixin";
import "ceres/app/mixins/template.mixin";

// =========================
// Bootstrap frameworks
// =========================
import "./app/main";

import TranslationService from "ceres/app/services/TranslationService";
import { createStore, initClientListeners, initClientStore, initServerStore } from "./app/store";
import { initListener } from "ceres/app/services/ApiService";

window.ceresTranslate = TranslationService.translate;

Vue.prototype.$translate = TranslationService.translate;
Vue.prototype.$ceres = App;

const store = createStore();

window.ceresStore = store;

initServerStore(store);
initClientStore(store);
initClientListeners(store);
initListener();

